import { combineReducers } from "redux";
import appReducer from "reducers/appReducer";

const rootReducer = combineReducers({
  appStore: appReducer,
});

export default rootReducer;
